export function openDialog() {
  return {
    type: '@dialog/OPEN',
  };
}

export function closeDialog() {
  return {
    type: '@dialog/CLOSE',
  };
}
